module.exports = __webpack_public_path__ + "img/carve_velocityfield.27cd3bb4.gif";